import React from "react";

export const PopupHeader = React.memo(function PopupHeader(props: {
  children?: React.ReactNode;
}) {
  return (
    <h3 className="text-heading leading-[normal] font-bold text-body-text">
      {props.children}
    </h3>
  );
});
